module.exports = __webpack_public_path__ + "img/certik.dd5952bf.png";